import axios from "axios";
import bMd5 from "blueimp-md5";
import { v4 as uuidv4 } from "uuid";
// import { getConfirm, getToast } from "@/components/Popup";
import { getToast, getConfirm } from "@/components/Login/popupLogin";

axios.defaults.baseURL = ENV_DATA.baseURL;
const SIGN = ENV_DATA.SIGN;
function createReq(method, path) {
  if (typeof method !== "string") {
    return "";
  }
  method = method.toUpperCase();
  return method + path || "";
}
function createSign(params = {}) {
  let data = {
    signAppId: SIGN.signAppId,
    ...params,
  };
  let paramsArr = [];
  for (let k in data) {
    paramsArr.push(`${k}=${data[k]}`);
  }
  paramsArr.sort((a, b) => {
    return (a + "").localeCompare(b + "");
  });
  return paramsArr.join("&");
}
function fmtSign({ method, path, params } = {}) {
  let str =
    createReq(method, path) +
    "?" +
    createSign(params) +
    SIGN.signAppSecurity +
    "signsh";
  // console.log("==123==");
  // console.log(path);
  // console.log("==1234==");
  // console.log(str);
  // console.log("==12345==");
  // console.log(bMd5(str));
  return bMd5(str);
}
axios.interceptors.request.use(
  (config) => {
    // 默认所有接口都加入token Bearer
    if (
      localStorage.getItem("accessToken") &&
      localStorage.getItem("accessToken") !== "undefined"
    ) {
      config.headers["Authorization"] = `Bearer ${localStorage
        .getItem("accessToken")
        .replace(/"/g, "")}`; // 让每个请求携带token--['X-Token']为自定义key 请根据实际情况自行修改
    }
    // if (process.env.NODE_ENV === "development") {
    //   config.headers.Authorization =
    //     "Bearer eyJhbGciOiJIUzI1NiJ9.eyJhY2NvdW50SWQiOjE2ODA0NzgwOTUwODkxNTYwOTgsImFjY291bnRUeXBlIjoiV0VDSEFUIiwic3ViamVjdFR5cGUiOiJVU0VSIiwidXNlcklkIjozNTc0Miwic3ViamVjdElkIjozNTc0MiwiaWF0IjoxNjg5NDk4Njg1LCJpc3MiOiJtYWRlIGJ5IEh5Q2FuIiwiZXhwIjoxNjkxNjU4Njg1fQ.W6zoZ3tMliulBz4FI9H_RbVMS63eLMhCz_z43SW42wQ";
    // }

    let appTimestamp = Date.parse(new Date()) / 1000;
    let appRequestId = uuidv4();
    let params = {
      method: config.method,
      path: config.url,
      params: {
        appTimestamp,
        appRequestId,
      },
    };
    if (config.method === "post") {
      let dataStr = JSON.stringify(config.data);
      params.params = {
        ...params.params,
        jsonBody: dataStr,
      };
    } else {
      params.params = {
        ...params.params,
        ...config.params,
      };
    }
    let sign = fmtSign(params);
    if (sign) {
      config.headers["signAppId"] = SIGN.signAppId;
      config.headers["appTimestamp"] = appTimestamp;
      config.headers["appRequestId"] = appRequestId;
      config.headers["paramSign"] = sign;
    }
    return config;
  },
  (error) => {
    return error;
  }
);
axios.interceptors.response.use(
  (resp) => {
    // console.log(resp);
    const { code, msg, data } = resp.data || {};
    const url = new URL(window.location.href);
    if (code) {
      if (code === 667 || code === 666) {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("userInfo");
        localStorage.removeItem("needAuth");
        getToast().open({
          text: "登录失效，请重新登录！",
        });
        if (url.href.includes("/optional.html")) {
          window.location.href = "./optional.html";
        }
        window.location.href = "./login.html";

        return Promise.reject(`${msg}`);
      }
      const title = {
        请输出正确的手机号: "手机号错误",
        "验证码不正确,请重新输入": "验证码不正确",
        今日验证码次数已达上限: "请在明日再重新登录。",
      };
      getConfirm().open({
        title: title[msg] || "提示",
        content: msg,
      });
      return Promise.reject(resp.data);
    }
    // console.log("data", data);
    // if (data.data && data.data.code) {
    //   console.error("报错参数:", data);
    //   getToast().open({
    //     text: data.data.msg || "网络请求错误！",
    //   });
    //   return Promise.reject(`${data.data.msg}`);
    // }
    return resp.data;
  },
  (error) => {
    getConfirm().open({
      title: "提示",
      content: "网络请求错误！",
    });
    return Promise.reject(error);
  }
);
export default axios;
